// extracted by mini-css-extract-plugin
module.exports = {"container":"CatalogMainPage_container__Y7FIJ"};